/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Page, Button, Container, Box } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { ModalContext } from "../../components/BrowserAlert/modalContext";

import { Header, ToggleViews } from "../../components";
import { ServiceTableView } from "./ServiceTableView";
import { ServiceListView } from "./ServiceListView";
import { ServiceCardView } from "./ServiceCardView";

import { CreateServiceDialog } from "./CreateServiceDialog";

import { getOrgServiceTypes } from "../../services/services";
import { Add } from "@mui/icons-material";

import { RemoveServiceDialog } from "./RemoveServiceDialog";

// import { services } from "../../__mocks__";
export const Services = () => {
  let { handleModal } = React.useContext(ModalContext);
  const [view, setView] = useState("table-view");
  const [maintenancePlans, setMaintenancePlans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openRemoveDialog, setOpenRemoveDialog] = React.useState(false);
  const [currentMaintenancePlanId, setCurrentMaintenancePlanId] =
    React.useState(undefined);
  const [currentOrgId, setCurrentOrgId] = React.useState(undefined);
  const handleView = (event, newView) => {
    setView(newView);
  };
  let history = useHistory();
  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    init();
  }, []);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  async function init() {
    try {
      let services = await getOrgServiceTypes("zriT");
      setMaintenancePlans(services);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setMaintenancePlans([]);
      // alert(error);
      handleModal(error, "Alert");
      // alert(error);
    }
  }

  const displayData = () => {
    switch (view) {
      case "list-view":
        return (
          <ServiceListView isLoading={isLoading} data={maintenancePlans} />
        );

      case "card-view":
        return (
          <ServiceCardView isLoading={isLoading} data={maintenancePlans} />
        );

      default:
        return (
          <ServiceTableView
            isLoading={isLoading}
            data={maintenancePlans}
            setCurrentOrgId={setCurrentOrgId}
            setCurrentMaintenancePlanId={setCurrentMaintenancePlanId}
            setOpenRemoveDialog={setOpenRemoveDialog}
          />
        );
    }
  };

  return (
    <Page title="FlukeWorks">
      <Header
        xl
        menuBar
        name={`Services (${maintenancePlans.length || 0})`}
        history={history}
        action={
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            // onClick={() => history.push(`/services/create`)}
            onClick={() => setOpenDialog(true)}
            style={{ textTransform: "normal !important" }}
          >
            Create Service
          </Button>
        }
      />
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        <Box sx={{ my: 2 }}>
          <ToggleViews view={view} handleView={handleView} />
        </Box>
        {displayData()}
      </Container>
      <CreateServiceDialog handleClose={handleCloseDialog} open={openDialog} />
      <RemoveServiceDialog
        handleClose={() => {
          setCurrentMaintenancePlanId(undefined);
          setOpenRemoveDialog(false);
        }}
        currentMaintenancePlanId={currentMaintenancePlanId}
        currentOrgId={currentOrgId}
        open={openRemoveDialog}
        getMaintenancePlans={getOrgServiceTypes}
        setMaintenancePlans={setMaintenancePlans}
        // need update
        // setMaintenancePlans={setMaintenancePlans}
      />
    </Page>
  );
};
